export function getRcsAudienceError(data) {
  if (data.selectedGroup) {
    if (data.dbGroup === "database" && data.contactSelectionMode === "ai" && (!data.dbquery?.filter || !(data.audienceCount > 0))) {
      return "Create and confirm an AI audience to continue";
    }
    if (data.dbGroup === "database" && data.contactSelectionMode === "range" &&
      (!Number.isSafeInteger(data.startIndex) || !Number.isSafeInteger(data.endIndex) || data.startIndex < 1 || data.endIndex < data.startIndex)) {
      return "Confirm a valid database range to continue";
    }
    return null;
  }
  return data.contacts.some((contact) => contact.selected) ? null : "Add contacts or confirm an audience to continue";
}

export function buildRcs2CampaignPayload(data, { contactGroupName, campaignGroupName }) {
  const database = data.selectedGroup && data.dbGroup === "database";
  return {
    campaignName: data.campaignName.trim(),
    templateId: data.template.templateId,
    contacts: data.selectedGroup ? [] : data.contacts.filter((contact) => contact.selected),
    selectedGroup: data.selectedGroup || undefined,
    dbGroup: data.selectedGroup ? data.dbGroup : undefined,
    startIndex: data.selectedGroup ? data.startIndex : undefined,
    endIndex: data.selectedGroup ? data.endIndex : undefined,
    ...(database && data.contactSelectionMode ? {
      contactSelectionMode: data.contactSelectionMode,
      ...(data.contactSelectionMode === "ai" ? { dbquery: data.dbquery } : {}),
    } : {}),
    contactGroupName,
    campaignGroupName,
  };
}
